import SummaryPage from './SummaryPage';
export { SummaryPage };
export default SummaryPage;
